const getRandomPercent = () => {

    // 10-40 vs 50-90
    const percents = [Math.floor(Math.random() * (40 - 10 + 1)) + 10, Math.floor(Math.random() * (90 - 50 + 1)) + 50];
    return {
        background: `linear-gradient(to right, var(--themeCyan) ${percents[0]}%, var(--themeMagenta) ${percents[1]}%, var(--themeYellow) 100%)`
    }
    // const first = (Math.random() * (48 - 13 + 1)) + 13;
    // const second = (Math.random() * (80 - 51 + 1)) + 51;

    // const gradientValues = [first, second]

    // const dynamicGradientStyle = {
    //     '--gradient-stop-2': `${gradientValues[0]}%`,
    //     '--gradient-stop-3': `${gradientValues[0]}%`,
    //     '--gradient-stop-4': `${gradientValues[1]}%`,
    //     '--gradient-stop-5': `${gradientValues[1]}%`,
    // };

    // return dynamicGradientStyle;
};

export default getRandomPercent;